import React, { useEffect, useState } from 'react';
import { getStudent360, isUuid } from '../../api/students360';
import { useI18n } from '../../i18n/I18nContext';
import PresenceBadge, { LastLogin } from './PresenceBadge';
import LessonLine from './LessonLine';
import { nowFrom } from './time';
import './Student360.css';

/**
 * A strip for the teacher portal's student page: when the student was last seen and last signed
 * in, and which lesson of this course they are on. The page below it keeps its own data; this is
 * read from GET /crm/students/:id (narrowed to the course) and left out entirely when that fails,
 * for instance when the student is outside what the signed-in account may open.
 */
function StudentPresenceHeader({ studentId, courseId }) {
  const { t } = useI18n();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isUuid(studentId)) return undefined;
    let cancelled = false;
    setData(null);
    getStudent360(studentId, { courseId })
      .then((detail) => { if (!cancelled) setData(detail); })
      .catch(() => { /* the header is an extra */ });
    return () => { cancelled = true; };
  }, [studentId, courseId]);

  if (!data) return null;
  const enrollments = Array.isArray(data.enrollments) ? data.enrollments : [];
  const enrollment = enrollments.find((item) => item.courseId === courseId) || enrollments[0];
  const hasLesson = enrollment && enrollment.currentLesson !== undefined;
  if (!data.presence && !hasLesson) return null;
  const now = nowFrom(data.meta);

  return (
    <div className="s360-teacher-head">
      {data.presence && (
        <>
          <div className="s360-fact">
            <span className="s360-label">{t('student360.presence.lastSeen')}</span>
            <PresenceBadge presence={data.presence} now={now} />
          </div>
          <div className="s360-fact">
            <span className="s360-label">{t('student360.presence.lastLogin')}</span>
            <LastLogin presence={data.presence} now={now} />
          </div>
        </>
      )}
      {hasLesson && (
        <div className="s360-fact is-wide">
          <span className="s360-label">{t('student360.lesson.current')}</span>
          <LessonLine lesson={enrollment.currentLesson} now={now} />
        </div>
      )}
    </div>
  );
}

export default StudentPresenceHeader;
